module.exports = __webpack_public_path__ + "static/media/harvardx_logo.3ccfdbfb.webp";